import React, { useEffect } from 'react';
import Page from '../components/Page';
import { Tabs } from 'antd';
import { connect } from 'react-redux';
import { Actions } from '../store/actions';
import VehicleFeatureManagement from './util/feature/VehicleFeatureManagement';
import ColorManagement from './util/color/ColorManagement';
import VehicleBodyTypeManagement from './util/bodyType/VehicleBodyTypeManagement';
import VehicleEngineTypeManagement from './util/engineType/VehicleEngineTypeManagement';
import CityManagement from './util/city/CityManagement';

const VehicleUtil = ({ utils, fetchVehicleUtils, activeTabKey, updateActiveTab }) => {
	useEffect(() => {
		fetchVehicleUtils();
	}, []);

	const handleClick = (key) => {
		updateActiveTab(key);
	};

	return (
		<Page title="Vehicle Util Page" className="vehicle-util-page">
			<Tabs onChange={handleClick} className="vehicle-util-tabs" activeKey={activeTabKey} destroyInactiveTabPane={true}>
				<Tabs.TabPane tab="Feature" key="1">
					<VehicleFeatureManagement features={utils?.features} />
				</Tabs.TabPane>
				<Tabs.TabPane tab="Color" key="2">
					<ColorManagement colors={utils?.colors} />
				</Tabs.TabPane>
				<Tabs.TabPane tab="Body Type" key="3">
					<VehicleBodyTypeManagement bodyTypes={utils?.bodyTypes} />
				</Tabs.TabPane>
				<Tabs.TabPane tab="Engine Type" key="4">
					<VehicleEngineTypeManagement engineTypes={utils?.engineTypes} />
				</Tabs.TabPane>
				<Tabs.TabPane tab="City" key="5">
					<CityManagement />
				</Tabs.TabPane>
			</Tabs>
		</Page>
	);
};

const mapStateToProps = (store) => ({
	utils: store.vehicleUtil.utils,
	activeTabKey: store.activeTabKey.activeTabKey,
});

const mapDispatchToProps = (dispatch) => ({
	fetchVehicleUtils: () => dispatch(Actions.fetchVehicleUtils()),
	updateActiveTab: (key) => dispatch(Actions.updateActiveTab(key)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VehicleUtil);
